/* eslint-disable react-hooks/exhaustive-deps */
import { LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'
import { TablePaginationParams } from 'components/core-v2/molecules/table-pagination'
import { useEffect } from 'react'
import { useUser } from 'utilities/hooks/useUser'

import { getUserDisplayInfo } from '../tradebuilder-v2/util/user'
import FundsLayout from './layout/funds-layout'
import { actions as rawActions, FundsSearchFilter } from './state/funds-slice'
import { useAppSelector } from './store/hooks'
import { useActions } from './store/use-actions'

export const FundsReinvestmentPage = () => {
  const { data: user } = useUser()
  const fundActions = useActions(rawActions)
  const state = useAppSelector(state => state.funds)
  const paginationParams: TablePaginationParams = {
    pageNumber: state.query.PageNumber,
    pageSize: state.query.PageSize,
    totalRows: state.numTotalTrades
  }

  const userInfo = getUserDisplayInfo(user)

  useEffect(() => {
    fundActions.init(userInfo)
  }, [])

  const onPaginationChange = (updatedPagination: TablePaginationParams) => {
    fundActions.setPage(updatedPagination)
  }

  const onFilterChange = (updatedFilter: FundsSearchFilter) => {
    fundActions.setServerFilter(updatedFilter)
  }
  return (
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={
        <FundsLayout
          filter={state.filter}
          funds={state.funds}
          fundsAlerts={state.fundsAlerts}
          isLoading={state.isLoading}
          paginationParams={paginationParams}
          totalNumFunds={state.numTotalTrades}
          onFilterChange={onFilterChange}
          onPaginationChange={onPaginationChange}
        />
      }
      topBarElement={<UserMenuTopBar />}
    />
  )
}
